import { render, staticRenderFns } from "./BrkDatePicker.vue?vue&type=template&id=169e6da6"
import script from "./BrkDatePicker.vue?vue&type=script&lang=js"
export * from "./BrkDatePicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports